import { render, staticRenderFns } from "./staticField.vue?vue&type=template&id=6969ae39&"
import script from "./staticField.vue?vue&type=script&lang=ts&"
export * from "./staticField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports